import { Card, CardContent, Typography, Box, IconButton, Tooltip } from "@mui/material";
import { Code, ContentCopy } from "@mui/icons-material";
import { styled } from "@mui/system";
import { useState, useEffect } from "react";
import { OrganizationDocument, useFirebaseService } from "../../../data/FirebaseService";

const CodeBlock = styled("pre")(({ theme }) => ({
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.grey[100],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    fontFamily: "monospace",
    overflowX: "auto",
}));

const InstallationInstructions = () => {
    const [organization, setOrganization] = useState<OrganizationDocument | null>(null);
    const [installCommand, setInstallCommand] = useState<string>("");
    const firebaseService = useFirebaseService();

    useEffect(() => {
        if (firebaseService) {
            const fetchOrganization = async () => {
                const organization = await firebaseService.getOrganizationDocument();
                setOrganization(organization);
                setInstallCommand(`msiexec /i reachr-setup.msi ORGID=${organization?.id} ORGKEY=${organization?.registrationKey}`);
            };

            fetchOrganization();
        }
    }, [firebaseService]);

    return (
        <Card sx={{ maxWidth: 800, p: 2 }}>
            <CardContent>
                {/* Title */}
                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <Code />
                    <Typography variant="h6">Installation Instructions</Typography>
                </Box>

                {/* Overview Section */}
                <Typography variant="body1" paragraph>
                    Follow these steps to install and run the application on your system.
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    Open a terminal in Administrator mode and run the following command:
                </Typography>

                {/* Code Block */}
                <Box display="flex" alignItems="center">
                    <CodeBlock>
                        {installCommand}
                        <Tooltip title="Copy">
                            <IconButton
                                sx={{ ml: 2, color: (theme) => theme.palette.grey[100] }}
                                onClick={() => navigator.clipboard.writeText(installCommand)}
                            >
                                <ContentCopy />
                            </IconButton>
                        </Tooltip>
                    </CodeBlock>
                </Box>

                <Typography variant="body2" color="text.secondary" mt={1}>
                    This will install the app configured to run against this organization.
                </Typography>
            </CardContent>
        </Card>
    );
};

export default InstallationInstructions;
